export enum SentAmestoStatus {
  Pending = 'Pending',
  Failed = 'Failed',
  PartiallySucceeded = 'PartiallySucceeded',
  Succeeded = 'Succeeded',
}
